module.exports = __webpack_public_path__ + "img/personal-authentication.a0925c64.png";